import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

const GroupApiUrl = (slug: string) => `/api/v2/groups/${slug}`;

@Injectable()
export class GroupsService {
  constructor(private http: HttpClient) {}

  public resolveGroup(groupSlug: string) {
    const url = GroupApiUrl(groupSlug);
    return this.http.get(url);
  }
}
